import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  userInfo: any;
  public defaultImage = '../../../../../assets/images/profile/profile.png';
  public userImage:any;
  public updatedImage:any;
  public enableProfileCard:boolean = false;

  constructor(
    public storage: StorageService,
    public api: ApiService,
    public swal: SweetAlert,
    public router: Router,
    public file: FileUploadService,
  ) { }

  ngOnInit(): void {
    this. getUserData();
  }
  getUserData() {
    this.api.GetCurUserOrg({}).then((res: any) => {
      if (res.status == 'success') {
        this.userInfo = res.data[0];
        this.enableProfileCard = true;
        this.userImage = this.userInfo['profilePic'];
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });
  }

  async handleUpload(event) {
    console.log(event.target.files[0])
    this.updatedImage = await this.file.fileHandeleBase64(event);
    this.updateUserData();
  }

  updateImage(){
    document.getElementById('profile').click();
  }
  updateUserData() {
    let obj = {
      profilePic:this.updatedImage,
    }
    this.api.updateCurUserOrg(obj).then((res: any) => {
      console.log('response',res);
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        setTimeout(()=>{ 
          this.enableProfileCard = false;
          console.log('profile get')
          this.getUserData() 
        }, 2500)
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });
  }

  
}
